<template>
  <div class="composite">
    <div style="margin: 18px 0">
      <Breadcrumb :breadcrumb="breadcrumb" />
    </div>
    <!-- 搜索筛选区域 -->
    <div class="tabs">
      <a-tabs v-model="activeKey" @change="callback">
        <!-- 个案帮扶 -->
        <a-tab-pane key="1" tab="个案帮扶">
          <div class="formDom">
            <Form
              ref="moneyForm"
              :dataSource="getData"
              id="moneyForm"
              @cleanTime="moneyFormCleanTime"
            >
              <template v-slot:button>
                <div style="text-align: right; margin-top: 4px">
                  <a-button type="primary" @click="search">查询</a-button>
                  <a-button :style="{ marginLeft: '8px' }" @click="reset">重置</a-button>

                  <download-excel
                    :data="excel_content"
                    :fields="excel_biaotou"
                    worksheet="sheet1"
                    name="个案帮扶.xls"
                    :before-generate="startDownload"
                    :before-finish="endDownload"
                    style="display: inline; margin-left: 10px"
                  >
                    <a-button icon="download" type="primary">导出</a-button>
                  </download-excel>
                </div>
              </template>
            </Form>
          </div>
        </a-tab-pane>
        <!-- 项目帮扶 -->
        <a-tab-pane key="2" tab="项目帮扶" v-if="userInfo.municipal_tree_level.length<5">
          <div class="formDom">
            <Form
              ref="activeForm"
              :dataSource="getData"
              id="activeForm"
              @cleanTime="activeFormCleanTime"
            >
              <template v-slot:button>
                <div style="text-align: right; margin-top: 4px">
                  <a-button type="primary" @click="search">查询</a-button>
                  <a-button :style="{ marginLeft: '8px' }" @click="reset">重置</a-button>
                  <download-excel
                    :data="excel_content2"
                    :fields="excel_biaotou2"
                    worksheet="sheet1"
                    name="项目帮扶.xls"
                    :before-generate="startDownload2"
                    :before-finish="endDownload2"
                    style="display: inline; margin-left: 10px"
                  >
                    <a-button icon="download" type="primary">导出</a-button>
                  </download-excel>
                </div>
              </template>
            </Form>
          </div>
        </a-tab-pane>
        <!-- 帮扶对象 -->
        <a-tab-pane key="3" tab="帮扶对象">
          <div class="formDom">
            <Form ref="peopleForm" :dataSource="getData" id="peopleForm">
              <template v-slot:button>
                <div style="text-align: right; margin-top: 4px">
                  <a-button type="primary" @click="search">查询</a-button>
                  <a-button :style="{ marginLeft: '8px' }" @click="reset">重置</a-button>
                  <download-excel
                    :data="excel_content3"
                    :fields="excel_biaotou3"
                    worksheet="sheet1"
                    name="帮扶对象.xls"
                    :before-generate="startDownload3"
                    :before-finish="endDownload3"
                    style="display: inline; margin-left: 10px"
                  >
                    <a-button icon="download" type="primary">导出</a-button>
                  </download-excel>
                </div>
              </template>
            </Form>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
    <!-- table列表区域 -->
    <!-- 个案帮扶table -->
    <div
      class="table"
      style="margin-top: 10px; background: #fff; border-radius: 2px"
      v-if="activeKey && activeKey === '1'"
    >
      <a-table
        :columns="columns"
        :data-source="data"
        @change="changePage"
        :loading="loading"
        :pagination="pagination"
        :rowKey="
          (record) => {
            record.process_base_id
          }
        "
        :rowClassName="tableRowClassName"
      >
        <span slot="name" slot-scope="text, data1, index">{{ index + 1 }}</span>
        <span slot="action" slot-scope="text, data2">
          <a @click="view('个案帮扶', data2)">查看</a>
          <!--<a-divider type="vertical" v-if="getIsShow(data)"/>-->
          <!--<a v-if="getIsShow(data)" @click="edit('fund',data)">编辑</a>-->
          <!--<a-divider type="vertical" />-->
          <!--<a >审批 </a>-->
        </span>
      </a-table>
      <!--<div style="text-align: right;margin:16px;padding-bottom:16px;" v-if="data&&data.length>0">-->
      <!--<a-pagination  :default-current="1"   :total="1" @change="changePage" />-->
      <!--</div>-->
    </div>
    <!-- 项目帮扶table -->
    <div
      class="table"
      style="margin-top: 10px; background: #fff; border-radius: 2px"
      v-if="activeKey && activeKey === '2'"
    >
      <a-table
        :columns="activeColumns"
        :data-source="activeData"
        @change="changePage"
        :pagination="pagination"
        :loading="loading"
        :rowKey="
          (record) => {
            record.process_base_id
          }
        "
      >
        <span slot="name" slot-scope="text, data1, index">{{ index + 1 }}</span>
        <span slot="action" slot-scope="text, data2">
          <a @click="view('项目帮扶', data2)">查看</a>
          <!--<a-divider type="vertical" />-->
          <!--<a >审批 </a>-->
        </span>
      </a-table>
      <!--<a-pagination show-quick-jumper :default-current="1" :total="500" @change="onChange" />-->
    </div>
    <!-- 帮扶对象table -->
    <div
      class="table"
      style="margin-top: 10px; background: #fff; border-radius: 2px"
      v-if="activeKey && activeKey === '3'"
    >
      <a-table
        :columns="peopleColumns"
        :data-source="peopleData"
        @change="changePage"
        :pagination="pagination"
        :loading="loading"
        :rowKey="(record) => record.need_help_person_id"
        :rowClassName="tableRowClassName"
      >
        <span slot="name" slot-scope="text, data1, index">{{ index + 1 }}</span>
        <span slot="action" slot-scope="text, data2">
          <a @click="view('帮扶对象', data2)">查看</a>
        </span>
      </a-table>
      <!--<a-pagination show-quick-jumper :default-current="1" :total="500" @change="onChange" />-->
    </div>

    <div class="zhezhao-view" v-if="zhezhao_show">
      <a-spin tip="数据导出中,请稍等..." />
    </div>
  </div>
</template>

<script>
// import cardTitle from './components/cardTitle'
import Form from '@/components/GlobalForm'
import Breadcrumb from '@/components/breadcrumb'
// import SelectPeople from '../components/selectPeople'
import { forms } from './formData'
import { service } from './service'
import store from '@/store'
import request from '@/utils/request'
const columns = [
  {
    title: '申请人',
    dataIndex: 'need_help_person_name',
    key: 'need_help_person_name',
    ellipsis: true
  },
  {
    title: '申请时间',
    dataIndex: 'individual_case_apply_time',
    key: 'individual_case_apply_time',
    width: 200
  },
  {
    title: '录入机构',
    dataIndex: 'draftAddress',
    key: 'draftAddress',
    ellipsis: true
  },
  {
    title: '金额',
    dataIndex: 'individual_case_support_funds',
    key: 'individual_case_support_funds',
    ellipsis: true
  },
  {
    title: '状态',
    dataIndex: 'process_status',
    key: 'process_status',
    ellipsis: true
  },
  {
    title: '操作',
    key: 'action',
    width: '140px',
    scopedSlots: { customRender: 'action' }
  }
]
const activeColumns = [
  {
    title: '项目名称',
    dataIndex: 'process_base_title',
    key: 'process_base_title',
    ellipsis: true
  },
  {
    title: '项目资金',
    dataIndex: 'project_funding',
    key: 'project_funding',
    width: 130,
    ellipsis: true
  },
  // {
  //   title: '项目负责',
  //   dataIndex: 'project_responsible_person',
  //   key: 'project_responsible_person',
  //   ellipsis: true
  // },
  {
    title: '项目类型',
    dataIndex: 'projectType',
    key: 'projectType',
    width: 130,
    ellipsis: true
  },
  {
    title: '开始时间',
    dataIndex: 'start_time',
    key: 'start_time',
    width: 130,
    ellipsis: true
  },
  {
    title: '结束时间',
    dataIndex: 'end_tima',
    key: 'end_tima',
    width: 120,
    ellipsis: true
  },
  {
    title: '项目发起方',
    dataIndex: 'project_sponsor',
    key: 'project_sponsor',
    ellipsis: true
  },
  {
    title: '项目状态',
    dataIndex: 'process_status',
    key: 'process_status',
    width: 130,
    ellipsis: true
  },
  {
    title: '操作',
    key: 'action',
    width: '140px',
    scopedSlots: { customRender: 'action' }
  }
]
const peopleColumns = [
  {
    title: '身份证号',
    dataIndex: 'need_help_person_number_id',
    key: 'need_help_person_number_id',
    width: 180,
    ellipsis: true
  },
  {
    title: '姓名',
    dataIndex: 'need_help_person_name',
    key: 'need_help_person_name',
    ellipsis: true,
    width: 100
  },
  {
    title: '性别',
    dataIndex: 'need_help_person_gender',
    key: 'need_help_person_gender',
    ellipsis: true,
    width: 60
  },
  {
    title: '民族',
    dataIndex: 'need_help_person_nation',
    key: 'need_help_person_nation',
    ellipsis: true,
    width: 100
  },
  // {
  //   title: '家庭成员数量',
  //   dataIndex: 'need_help_person_family_number',
  //   key: 'need_help_person_family_number',
  //   ellipsis: true,
  //   width: 120
  // },
  {
    title: '居住地',
    dataIndex: 'need_help_person_current_address_city',
    key: 'need_help_person_current_address_city',
    ellipsis: true,
    width: 150
  },
  // {
  //   title: '年收入(元/年)',
  //   dataIndex: 'need_help_person_family_income',
  //   key: 'need_help_person_family_income',
  //   ellipsis: true,
  //   width: 120
  //
  // },
  // {
  //   title: '人均住房面积(㎡)',
  //   dataIndex: 'need_help_person_fmily_housing',
  //   key: 'need_help_person_fmily_housing',
  //   ellipsis: true,
  //   width: 150
  // },
  {
    title: '家庭类别',
    dataIndex: 'need_help_person_poverty_type',
    key: 'need_help_person_poverty_type',
    ellipsis: true,
    width: 90
  },
  // {
  //   title: '归属帮扶项目',
  //   dataIndex: 'project_base_title',
  //   key: 'project_base_title',
  //   ellipsis: true,
  //   width: 130
  // },
  {
    title: '操作',
    key: 'action',
    width: 160,
    fixed: 'right',
    scopedSlots: { customRender: 'action' }
  }
]
export default {
  name: 'Index',
  components: {
    // cardTitle,
    Breadcrumb,
    Form
    // SelectPeople
  },
  data() {
    return {
      userInfo: this.$store.getters.userInfo ? this.$store.getters.userInfo.user : {},
      zhezhao_show: false,
      // value: ['a1', 'b2'],
      columns, // 资金
      params: {}, // search查询信息
      activeColumns, // 活动
      peopleColumns,
      newShow: false,
      data: [],
      activeData: [],
      peopleData: [],
      pagination: {
        // 分页
        current: 1,
        pageSize: 12,
        total: 0,
        showTotal: (total) => `共 ${total} 条数据`

      },
      breadcrumb: [
        {
          title: '综合帮扶',
          path: ''
        },
        {
          title: '项目帮扶',
          path: ''
        }
      ],
      activeKey: '1',
      loading: true,
      allquList: [],
      kaizhanquyuTreeData: [], // 开展区域，树形数据
      excel_biaotou: {
        // 个案帮扶 导出excel的表头设计
        申请人: 'need_help_person_name',
        申请时间: 'process_base_draft_date',
        录入机构: 'draftAddress',
        金额: 'individual_case_support_funds',
        状态: 'process_status'
      },
      excel_content: [],
      excel_biaotou2: {
        // 项目帮扶 导出excel的表头设计
        项目名称: 'process_base_title',
        项目资金: 'project_funding',
        项目类型: 'projectType',
        开始时间: 'start_time',
        结束时间: 'end_tima',
        项目发起方: 'project_sponsor',
        项目状态: 'process_status'
      },
      excel_content2: [],
      excel_biaotou3: {
        // 帮扶对象 导出excel的表头设计
        身份证号: 'need_help_person_number_id',
        姓名: 'need_help_person_name',
        性别: 'need_help_person_gender',
        民族: 'need_help_person_nation',
        居住地: 'need_help_person_current_address_city',
        家庭类别: 'need_help_person_poverty_type'
      },
      excel_content3: []
    }
  }, // 面包屑
  computed: {
    // 获取查询的form表单
    getData() {
      if (this.activeKey && this.activeKey === '1') {
        return forms.getFormData({}, this, this.allquList)
      } else if (this.activeKey && this.activeKey === '2') {
        return forms.getActiveData(this.kaizhanquyuTreeData, this)
      } else {
        return forms.getPeopleData({}, this)
      }
    }
  },
  created() {
    // this.getQuTreeData()
  },
  mounted() {
    const userInfo = store.getters.userInfo ? store.getters.userInfo.user : {}
    this.newShow = userInfo.user_permissions.find((value) => value === 'itemAssit_new')
    // this.getProcessList({
    //   process_label: 'Done',
    //   pageIndex: 1,
    //   pageSize: this.pagination.pageSize,
    //   process_config_type: 'releaseOfFunds'
    // })
    this.getQuTreeData()
    this.getKaizhanquyuTreeData()
    this.search()
  },
  methods: {
    async startDownload() {
      this.zhezhao_show = true
      await request({
        url: `/process/getIndividualList`,
        method: 'post',
        data: {
          pageIndex: 1,
          pageSize: 9999999,
          ...this.params
        }
      }).then((ret) => {
        this.zhuanhuan(ret, '1', true)
      })
    },
    endDownload() {
      this.zhezhao_show = false
      console.log('excel处理完成1')
    },
    async startDownload2() {
      this.zhezhao_show = true
      await request({
        url: `/process/getProjectList`,
        method: 'post',
        data: {
          pageIndex: 1,
          pageSize: 9999999,
          ...this.params
        }
      }).then((ret) => {
        this.zhuanhuan(ret, '2', true)
      })
    },
    endDownload2() {
      this.zhezhao_show = false
      console.log('excel处理完成2')
    },
    async startDownload3() {
      this.zhezhao_show = true
      await request({
        url: `/process/getPeopleList`,
        method: 'post',
        data: {
          pageIndex: 1,
          pageSize: 9999999,
          ...this.params
        }
      })
        .then((ret) => {
          this.zhuanhuan(ret, '3', true)
        })
        .catch((error) => {
          this.zhezhao_show = false
          this.$notification.warning({
            message: '导出失败,查询超时'
          })
          // 请求失败处理
          console.log(error + '导出错误回调')
        })
    },
    endDownload3() {
      this.zhezhao_show = false
      console.log('excel处理完成3')
    },
    // 获取所属区域的下拉数据
    getQuTreeData() {
      var userInfo = this.$store.getters.userInfo ? this.$store.getters.userInfo.user : {}
      request({
        url: `/auth/online/municipalTree`,
        method: 'post',
        data: {}
      }).then((ret) => {
        // 是基金会账号
        if (userInfo.municipal_tree_level === '0') {
          this.allquList = ret
        } else {
          // 是区账户
          if (userInfo.municipal_tree_level.length < 5) {
            this.allquList = JSON.parse(JSON.stringify(ret))
            this.allquList[0].children = []

            ret[0].children.forEach((item, index) => {
              if (item.title === userInfo.municipal_tree_name) {
                this.allquList[0].children.push(item)
              }
            })
          }
        }
      })
    },
    // 获取开展区域的 树形下拉数据
    getKaizhanquyuTreeData() {
      var userInfo = this.$store.getters.userInfo ? this.$store.getters.userInfo.user : {}
      request({
        url: `/auth/online/municipalTreeForProjectFund`,
        method: 'post',
        data: {}
      }).then((ret) => {
        // 是基金会账号
        if (userInfo.municipal_tree_level === '0') {
          this.kaizhanquyuTreeData = ret
        } else {
          // 是区账户
          if (userInfo.municipal_tree_level.length < 5) {
            this.kaizhanquyuTreeData = JSON.parse(JSON.stringify(ret))
            this.kaizhanquyuTreeData[0].children = []

            ret[0].children.forEach((item, index) => {
              if (item.title === userInfo.municipal_tree_name) {
                this.kaizhanquyuTreeData[0].children.push(item)
              }
            })
          }
        }
        this.kaizhanquyuTreeData[0].children.map((item, index) => {
          item.children = []
          return item
        })
      })
    },
    getFaqifangArrData() {
      var userInfo = this.$store.getters.userInfo ? this.$store.getters.userInfo.user : {}
      var areaData = [
        {
          label: '黄浦区',
          value: '黄浦区'
        },
        {
          label: '徐汇区',
          value: '徐汇区'
        },
        {
          label: '长宁区',
          value: '长宁区'
        },
        {
          label: '静安区',
          value: '静安区'
        },
        {
          label: '普陀区',
          value: '普陀区'
        },
        {
          label: '虹口区',
          value: '虹口区'
        },
        {
          label: '杨浦区',
          value: '杨浦区'
        },
        {
          label: '闵行区',
          value: '闵行区'
        },
        {
          label: '宝山区',
          value: '宝山区'
        },
        {
          label: '嘉定区',
          value: '嘉定区'
        },
        {
          label: '浦东新区',
          value: '浦东新区'
        },
        {
          label: '金山区',
          value: '金山区'
        },
        {
          label: '松江区',
          value: '松江区'
        },
        {
          label: '青浦区',
          value: '青浦区'
        },
        {
          label: '奉贤区',
          value: '奉贤区'
        },
        {
          label: '崇明区',
          value: '崇明区'
        },
        {
          label: '光明益群（农场）',
          value: '光明益群（农场）'
        }
      ]
      var cacheArr = []
      // 是基金会账号
      if (userInfo.municipal_tree_level === '0') {
        cacheArr = areaData
        cacheArr.unshift({
          label: '上海市帮困互助基金会',
          value: '上海市帮困互助基金会'
        })
        return cacheArr
      } else {
        // 是区账户
        if (userInfo.municipal_tree_level.length < 5) {
          cacheArr.push({
            label: '上海市帮困互助基金会',
            value: '上海市帮困互助基金会'
          })
          areaData.forEach((item, index) => {
            if (item.label === userInfo.municipal_tree_name) {
              cacheArr.push(item)
            }
          })
          return cacheArr
        }
      }
    },
    moneyFormCleanTime(e) {
      this.$refs.moneyForm.resetFields(e)
    },
    activeFormCleanTime(e) {
      this.$refs.activeForm.resetFields(e)
    },
    // tab切换
    callback(value) {
      this.activeKey = value
      if (value === '1') {
        this.$nextTick(() => {
          this.$refs.moneyForm.resetFields()
          this.pagination.current = 1
          this.search()
        })
      } else if (value === '2') {
        this.$nextTick(() => {
          this.$refs.activeForm.resetFields()
          this.pagination.current = 1
          this.search()
        })
      } else {
        this.$nextTick(() => {
          this.$refs.peopleForm.resetFields()
          this.pagination.current = 1
          this.search()
        })
      }
    },
    // 分页切换
    changePage(pagination) {
      this.pagination.current = pagination.current
      var url = ''
      if (this.activeKey && this.activeKey === '1') {
        url = '/process/getIndividualList'
      } else if (this.activeKey && this.activeKey === '2') {
        url = '/process/getProjectList'
      } else {
        url = '/process/getPeopleList'
      }
      request({
        url: url,
        method: 'post',
        data: {
          pageIndex: pagination.current,
          pageSize: this.pagination.pageSize,
          ...this.params
        }
      }).then((ret) => {
        this.zhuanhuan(ret, this.activeKey)
      })
    },
    // 查询
    search() {
      let params = {}
      if (this.activeKey && this.activeKey === '1') {
        this.pagination.current = 1
        params = this.$refs.moneyForm.getFieldsValue()
        if (params.shenqingDate.length > 0) {
          params.applyTimeStart = this.geshiTime(params.shenqingDate[0], 'date')
          params.applyTimeEnd = this.geshiTime(params.shenqingDate[1], 'date')
        }
        if (params.fafangDate.length > 0) {
          params.issuedTimeStart = this.geshiTime(params.fafangDate[0], 'date')
          params.issuedTimeEnd = this.geshiTime(params.fafangDate[1], 'date')
        }
        this.params = params
        request({
          url: `/process/getIndividualList`,
          method: 'post',
          data: {
            pageIndex: 1,
            pageSize: this.pagination.pageSize,
            ...params
          }
        }).then((ret) => {
          this.zhuanhuan(ret, this.activeKey)
        })
      } else if (this.activeKey && this.activeKey === '2') {
        this.pagination.current = 1
        params = this.$refs.activeForm.getFieldsValue()
        if (params.qidongDate.length > 0) {
          params.applyTimeStart = this.geshiTime(params.qidongDate[0], 'date')
          params.applyTimeEnd = this.geshiTime(params.qidongDate[1], 'date')
        }
        this.params = params
        request({
          url: `/process/getProjectList`,
          method: 'post',
          data: {
            pageIndex: 1,
            pageSize: this.pagination.pageSize,
            ...params
          }
        }).then((ret) => {
          this.zhuanhuan(ret, this.activeKey)
        })
      } else {
        this.pagination.current = 1
        params = this.$refs.peopleForm.getFieldsValue()
        this.params = params
        request({
          url: `/process/getPeopleList`,
          method: 'post',
          data: {
            pageIndex: 1,
            pageSize: this.pagination.pageSize,
            ...params
          }
        }).then((ret) => {
          this.zhuanhuan(ret, this.activeKey)
        })
      }
    },
    zhuanhuan(response, type, isExcel = false) {
      this.loading = false
      if (response) {
        var data = response.records || []
        var total = response.total
        //
        if (type && type === '1') {
          for (let i = 0; i < data.length; i++) {
            if (data[i].process_base_status) {
              if (data[i].process_base_status === 'Approval') {
                data[i].process_status = '待审批'
              } else if (data[i].process_base_status === 'Draft') {
                data[i].process_status = '申请中'
              } else if (data[i].process_base_status === 'Finish') {
                data[i].process_status = '待发放'
              } else if (data[i].process_base_status === 'ReturnDraft') {
                data[i].process_status = '退回（申请中）'
              } else if (data[i].process_base_status === 'Termination') {
                data[i].process_status = '终止'
              } else if (data[i].process_base_status === 'IsFinished') {
                data[i].process_status = '待发放'
              } else if (data[i].process_base_status === 'Finished') {
                data[i].process_status = '已完成'
              }
            }
            if (data[i].process_base_drafter) {
              data[i].draftAddress = data[i].process_base_drafter.municipal_tree_name // 录入机构
            }
            if (data[i].process_base_table_message) {
              data[i].process_base_table_message = JSON.parse(data[i].process_base_table_message)
              data[i].individual_case_apply_time = data[i].process_base_table_message
                .individual_case_apply_time
                ? data[i].process_base_table_message.individual_case_apply_time
                : ''
              data[i].need_help_person_name =
                data[i].process_base_table_message.need_help_person_name // 申请人
              data[i].individual_case_support_funds =
                data[i].process_base_table_message.individual_case_support_funds // 申请金额
            }
          }
          data.map((item, index) => {
              if (item.process_status === '待审批') {
                  if ((item.process_base_status === 'Approval' && item.process_config_step === 'street' && item.process_base_status_bit === 0) ||
                      (item.process_base_status === 'Approval' && item.process_config_step === 'Draft' && item.process_base_status_bit === 1)) {
                      item.process_status = '待审批（街镇）'
                  }

                  if ((item.process_base_status === 'Approval' && item.process_config_step === 'street' && item.process_base_status_bit === 1) ||
                      (item.process_base_status === 'Approval' && item.process_config_step === 'districtAndCounty' && item.process_base_status_bit === 0)) {
                      item.process_status = '待审批（区级）'
                  }
              }
              return item
          })
          if (isExcel) {
            this.excel_content = data
          } else {
            this.data = data
            this.pagination.total = total
          }
        } else if (type && type === '2') {
          for (let i = 0; i < data.length; i++) {
            if (data[i].process_base_deal_date == null) {
              if (data[i].process_config_step === '1') {
                data[i].process_status = '待申报'
              }
              if (data[i].process_config_step === '2') {
                data[i].process_status = '待复核'
              }
              if (data[i].process_config_step === '3') {
                data[i].process_status = '执行中'
              }
            } else {
              if (data[i].process_config_step === '3') {
                data[i].process_status = '结项'
              }
            }

            data[i].projectType =
              data[i].process_config_type === 'projectFund' ? '资金类' : '服务类' // 项目类型

            if (data[i].process_base_table_message) {
              data[i].process_base_table_message = JSON.parse(data[i].process_base_table_message)
              data[i].project_funding = data[i].process_base_table_message.project_funding // 项目资金
              data[i].project_sponsor = data[i].process_base_table_message.project_sponsor // 项目发起方
              data[i].start_time = data[i].process_base_table_message.start_time
              data[i].end_tima = data[i].process_base_table_message.end_time
              // data[i].project_stauts = data[i].process_base_table_message.project_stauts
              // 循环计算项目资金
              var xiangmuzijin = 0
              if (
                data[i].process_base_table_message.need_help_person &&
                data[i].process_base_table_message.need_help_person.length > 0 &&
                data[i].process_config_type === 'projectFund'
              ) {
                data[i].process_base_table_message.need_help_person.forEach((item, index) => {
                  xiangmuzijin = (
                    parseFloat(xiangmuzijin || 0) +
                    parseFloat(item.need_help_assistance_amount || 0)
                  ).toFixed(2)
                })
              } else {
                xiangmuzijin = '--'
              }

              data[i].project_funding = xiangmuzijin // 项目资金
            }
          }
          if (isExcel) {
            this.excel_content2 = data
          } else {
            this.activeData = data
            this.pagination.total = total
          }
        } else {
          var nationalList = this.$store.getters.nationalList
          data.forEach((item, index) => {
            if (item.need_help_person_current_address_city_str) {
              data[index].need_help_person_current_address_city = JSON.parse(
                item.need_help_person_current_address_city_str
              ).join('')
            }

            nationalList.forEach((item2, index2) => {
              if (item2.key === item.need_help_person_nation) {
                data[index].need_help_person_nation = item2.title
              }
            })
          })
          if (isExcel) {
            data.map((item, index) => {
              item.need_help_person_number_id = `'${item.need_help_person_number_id} `
              return item
            })
            this.excel_content3 = data
          } else {
            this.peopleData = data
            this.pagination.total = total
          }
        }
      }
    },
    // 重置
    reset() {
      if (this.activeKey && this.activeKey === '1') {
        this.$refs.moneyForm.resetFields()
        this.search()
      } else if (this.activeKey && this.activeKey === '2') {
        this.$refs.activeForm.resetFields()
        this.search()
      } else {
        this.$refs.peopleForm.resetFields()
        this.search()
      }
    },
    geshiTime(date, type = 'datetime') {
      var newdate = new Date(date)

      var fullYear = newdate.getFullYear()
      var month = newdate.getMonth() + 1
      var day = newdate.getDate()
      var hour = newdate.getHours()
      var min = newdate.getMinutes()
      var sec = newdate.getSeconds()
      if (type === 'datetime') {
        return `${fullYear}-${this.bulin(month)}-${this.bulin(day)} ${this.bulin(
          hour
        )}:${this.bulin(min)}:${this.bulin(sec)}`
      } else {
        return fullYear + '-' + this.bulin(month) + '-' + this.bulin(day)
      }
    },
    bulin(value) {
      if (value < 10) {
        return '0' + value
      }
      return value
    },
    // 新增项目,帮扶申请
    increaseItem() {
      if (this.activeKey === '1') {
        this.$router.push({
          path: '/assit/compositeAssit/increaseItem',
          query: { pageType: 'launch', processConfigType: 'projectFund' }
        })
      } else {
        this.$router.push({
          path: '/assit/compositeAssit/increaseItem',
          query: { pageType: 'launch', processConfigType: 'projectActivity' }
        })
      }
    },
    // 获取流程列表
    getProcessList(data) {
      this.loading = true
      this.data = []
      service.getProcessList(data, this.activeKey).then((response) => {
        this.data = response.data || []
        this.pagination.total = response.total || 0
        this.loading = false
      })
    },
    getIsShow(data) {
      // 判断是否展示编辑
      const userInfo = (this.$store.getters.userInfo && this.$store.getters.userInfo.user) || {}
      const id = userInfo.user_id
      if (data.process_base_drafter) {
        // data[i].process_base_drafter = JSON.parse(data[i].process_base_drafter)
        if (id === data.process_base_drafter.user_id && data.process_base_status === 'Finish') {
          return true
        }
      }
      return false
    },
    // 判断类型
    getType(data) {
      const userInfo = (this.$store.getters.userInfo && this.$store.getters.userInfo.user) || {}
      const id = userInfo.user_id
      if (data.process_base_drafter) {
        if (
          id === data.process_base_drafter.user_id &&
          data.process_base_status === 'ReturnDraft'
        ) {
          return true
        }
      }
      return false
    },
    edit(assitType, record) {
      // 跳转编辑上传活动报告
      const params = {
        process_base_work_number: record.process_base_work_number,
        process_base_status: record.process_base_status
      }
      if (assitType === 'fund') {
        // 判断是什么流程，就跳到什么页面，资金帮扶流程
        this.$router.push({
          path: '/assit/compositeAssit/increaseItem',
          query: { pageType: 'edit', processData: JSON.stringify(params) }
        })
      } else {
        // 活动帮扶流程
        this.$router.push({
          path: '/assit/compositeAssit/activeAssit',
          query: { pageType: 'edit', processData: JSON.stringify(params) }
        })
      }
    },
    view(assitType, record) {
      // 根据流程类型判断跳到哪个界面
      const type = 'view'

      if (assitType === '个案帮扶') {
        const params = {
          process_base_work_number: record.process_base_work_number,
          process_base_status: record.process_base_status
        }
        this.$router.push({
          path: '/assit/compositeAssit/increaseAssitPeople',
          query: { pageType: type, processData: JSON.stringify(params) }
        })
      } else if (assitType === '项目帮扶') {
        const params = {
          process_base_work_number: record.process_base_work_number,
          process_base_status: record.process_base_status,
          process_config_step: record.process_config_step,
          processConfigType: record.process_config_type
        }
        this.$router.push({
          path: '/assit/compositeAssit/increaseItem',
          query: { pageType: type, processData: JSON.stringify(params) }
        })
      } else if (assitType === '帮扶对象') {
        const params = {
          need_help_person_number_id: record.need_help_person_number_id
        }
        this.$router.push({
          path: '/assit/assitTarget/increaseAssitTarget',
          query: { pageType: 'view', processData: JSON.stringify(params) }
        })
      }
    },
    show(assitType, record) {
      // 根据流程类型判断跳到哪个界面
      let type = 'view'
      const params = {
        process_base_work_number: record.process_base_work_number,
        process_base_status: record.process_base_status
      }
      if (record.process_base_status && record.process_base_status === 'Approval') {
        // 判断流程状态类型
        type = 'view'
      } else if (record.process_base_status && record.process_base_status === 'ReturnDraft') {
        type = 'relaunch'
      } else if (record.process_base_status && record.process_base_status === 'Draft') {
        type = 'draft'
      } else if (
        record.process_base_status &&
        (record.process_base_status === 'Finish' || record.process_base_status === 'Termination')
      ) {
        type = 'view'
      }
      if (assitType === 'fund') {
        // 判断是什么流程，就跳到什么页面，资金帮扶流程
        this.$router.push({
          path: '/assit/compositeAssit/increaseItem',
          query: { pageType: type, processData: JSON.stringify(params) }
        })
      } else {
        // 活动帮扶流程
        this.$router.push({
          path: '/assit/compositeAssit/activeAssit',
          query: { pageType: type, processData: JSON.stringify(params) }
        })
      }
    },
      tableRowClassName(record, index) {
          if (record.status === '0' || record.need_help_person_status === '0') {
              return 'grey'
          }
      }
  }
}
</script>

<style scoped lang="less">
@import '../style.less';
.composite {
  .tabs {
    padding-top: 5px;
    background: #fff;
    border-radius: 2px;

    .formDom {
      padding: 0 20px;
      margin: 24px 0 11px 0;
    }
  }
  /deep/ .ant-tabs-nav-wrap{
    display: flex;
    justify-content: center;
    // background-color: red;
  }
  /deep/ .ant-tabs-nav-container {
    font-size: 14px;
    line-height: 20px;
    color: #333;
  }
  /deep/ .ant-tabs {
    width: 100%;
    height: 100%;
  }
  /deep/ .ant-tabs-tab {
    font-weight: 600;
    margin-right: 100px;
  }
  /deep/ .ant-tabs-nav .ant-tabs-tab:not(:last-child) {
    // margin-right: 168px;
  }
  /deep/ .ant-tabs-nav.ant-tabs-nav-animated {
    // margin-left: 280px;
  }
  /deep/ .ant-tabs-bar {
    margin-bottom: 0;
  }
}
.zhezhao-view {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  position: absolute;
  left: 0;
  top: 0;
  z-index: 992;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.ant-table-tbody .grey{
  background-color: #D3D3D3 !important;
}
</style>
